import AoneService from "../axiosbase";
//get VAT
export const getVat = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/vat" + params);
    } catch (error) {
      return error;
    }
  };
  //GET VAT by id
  export const getVatbyId = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/vat/" + params);
    } catch (error) {
      return error;
    }
  };
  //post VAT
  export const postVat = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/vat", data);
    } catch (error) {
      return error;
    }
  };
  //edit VAT
  export const editVat = async (params, data) => {
    try {
      return await AoneService.put(
        `masters/api/v1/vat/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //state update
  export const editVatState = async (params, data) => {
    try {
      return await AoneService.patch(
        `masters/api/v1/vat/state/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //delete VAT
  export const deleteVat = async (params) => {
    try {
      return await AoneService.delete("masters/api/v1/vat/" + params);
    } catch (error) {
      return error;
    }
  };
  export const bulkVatDelete = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/vat/delete", data);
    } catch (error) {
      return error;
    }
  };
  //exportVAT
  export const exportrateVat = async (params) => {
    try {
      return await AoneService.get(
        "masters/api/v1/vat/export" + params,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT template
  export const getVatTemplate = async () => {
    try {
      return await AoneService.get(
        "masters/api/v1/vat/template/download",
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT import
  export const importVat = async (data) => {
    try {
      return await AoneService.post(`masters/api/v1/vat/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };

  //GPA
//get GPA
export const getGpa = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/gpa" + params);
    } catch (error) {
      return error;
    }
  };
  //GET GPA by id
  export const getGpabyId = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/gpa/" + params);
    } catch (error) {
      return error;
    }
  };
  //post GPA
  export const postGpa = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/gpa", data);
    } catch (error) {
      return error;
    }
  };
  //edit GPA
  export const editGpa = async (params, data) => {
    try {
      return await AoneService.put(
        `masters/api/v1/gpa/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //patch GPA
  export const editGpaState = async (params, data) => {
    try {
      return await AoneService.patch(
        `masters/api/v1/gpa/state/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //delete GPA
  export const deleteGpa = async (params) => {
    try {
      return await AoneService.delete("masters/api/v1/gpa/" + params);
    } catch (error) {
      return error;
    }
  };
  export const bulkGpaDelete = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/gpa/delete", data);
    } catch (error) {
      return error;
    }
  };
  //export GPA
  export const exportrateGpa = async (params) => {
    try {
      return await AoneService.get(
        "masters/api/v1/gpa/export" + params,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //GPA template
  export const getGpaTemplate = async () => {
    try {
      return await AoneService.get(
        "masters/api/v1/gpa/template/download",
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //GPA import
  export const importGpa = async (data) => {
    try {
      return await AoneService.post(`masters/api/v1/gpa/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };

  //platform fee
export const getPlatformFee = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/rates/platform" + params);
    } catch (error) {
      return error;
    }
  };
  //GET VAT by id
  export const getPlatformbyId = async (params) => {
    try {
      return await AoneService.get(`masters/api/v1/rates/platform/${params}`);
    } catch (error) {
      return error;
    }
  };
  //post VAT
  export const postPlatform = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/rates/platform", data);
    } catch (error) {
      return error;
    }
  };
  //edit VAT
  export const editPlatform = async (params, data) => {
    try {
      return await AoneService.put(
        `masters/api/v1/rates/platform/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //state update
  export const editPlatformState = async (params, data) => {
    try {
      return await AoneService.patch(
        `masters/api/v1/rates/platform/state/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //delete VAT
  export const deletePlatform = async (params) => {
    try {
      return await AoneService.delete("masters/api/v1/rates/platform/" + params);
    } catch (error) {
      return error;
    }
  };
  export const bulkPlatformDelete = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/rates/platform/delete", data);
    } catch (error) {
      return error;
    }
  };
  //exportVAT
  export const exportratePlatform = async (params) => {
    try {
      return await AoneService.get(
        "masters/api/v1/rates/platform/export" + params,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT template
  export const getPlatformTemplate = async () => {
    try {
      return await AoneService.get(
        "masters/api/v1/rates/platform/template/download",
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT import
  export const importPlatform = async (data) => {
    try {
      return await AoneService.post(`masters/api/v1/rates/platform/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  //get platform lookups
  export const getPlatformList = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/Platform");
  } catch (error) {
    return error;
  }
};
//rebate rates
export const getRebate = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/rebate/rate/" + params);
    } catch (error) {
      return error;
    }
  };
  //GET Rebate by id
  export const getRebatebyId = async (params) => {
    try {
      return await AoneService.get("masters/api/v1/rebate/rate/" + params);
    } catch (error) {
      return error;
    }
  };
  //post Rebate
  export const postRebate = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/rebate/rate", data);
    } catch (error) {
      return error;
    }
  };
  //edit Rebate
  export const editRebate = async (params, data) => {
    try {
      return await AoneService.put(
        `masters/api/v1/rebate/rate/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //state update
  export const editRebateState = async (params, data) => {
    try {
      return await AoneService.patch(
        `masters/api/v1/rebate/rate/state/${params}`,
        data
      );
    } catch (error) {
      return error;
    }
  };
  //delete Rebate
  export const deleteRebate = async (params) => {
    try {
      return await AoneService.delete("masters/api/v1/rebate/rate/" + params);
    } catch (error) {
      return error;
    }
  };
  export const bulkRebateDelete = async (data) => {
    try {
      return await AoneService.post("masters/api/v1/rebate/rate/delete", data);
    } catch (error) {
      return error;
    }
  };
  //exportVAT
  export const exportrateRebate = async (params) => {
    try {
      return await AoneService.get(
        "masters/api/v1/rebate/rate/export" + params,
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT template
  export const getRebateTemplate = async () => {
    try {
      return await AoneService.get(
        "masters/api/v1/rebate/rate/template/download",
        {
          responseType: "blob",
        }
      );
    } catch (error) {
      return error;
    }
  };
  //VAT import
  export const importRebate = async (data) => {
    try {
      return await AoneService.post(`masters/api/v1/rebate/rate/import`, data, {
        "Content-Type": "multipart/form-data",
      });
    } catch (error) {
      return error;
    }
  };
  //get rebate mode
    export const getRebateMode = async () => {
  try {
    return await AoneService.get("masters/api/v1/lookups/RebateMode");
  } catch (error) {
    return error;
  }
};

